module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "summaryOrderWindow col-lg-12"
  }, [(_vm.getOrdersWindowList.next || _vm.getOrdersWindowList.prev) ? _c('div', {
    staticClass: "summaryOrderWindow-pagination"
  }, [_c('pagination-order-window', {
    attrs: {
      "paginationNext": _vm.getOrdersWindowList.next,
      "paginationPrev": _vm.getOrdersWindowList.prev
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('title-order-windows', {
    attrs: {
      "orderTitle": _vm.getOrdersWindowById.name
    }
  }), _vm._v(" "), _c('date-order-windows', {
    attrs: {
      "orderWindowDate": _vm.getOrdersWindowById
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summaryOrderWindow-content row"
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 listOrderWindow"
  }, [_c('list-details-order', {
    attrs: {
      "orderWindow": _vm.getOrdersWindow
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-xs-12 detailOrderWindow"
  }, [_c('orderSideBloc', {
    attrs: {
      "title": _vm.$t('orders.orderWindow.titleOrderWindowInformation')
    }
  }, [_c('order-window-information', {
    attrs: {
      "orderWindowDate": _vm.getOrdersWindowById
    }
  })], 1), _vm._v(" "), _c('orderSideBloc', {
    attrs: {
      "title": _vm.$t('orders.orderWindow.titleOrderWindowUpcoming')
    }
  }, [_c('upcoming-order-windows', {
    attrs: {
      "listOrderWindowUpcoming": _vm.getOrdersWindowList.list
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fa9f5a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/SummaryOrderWindow.vue
// module id = 3138
// module chunks = 0